import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import * as $ from 'jquery';
import * as _ from 'lodash';
import { EpahafService } from '../epahaf.service';
import { DatePipe } from '@angular/common';

// declare var $: any;
// declare var jQuery: any;

@Component({
    selector: 'app-pahaf-form',
    templateUrl: './pahaf-form.component.html',
    styleUrls: ['./pahaf-form.component.scss'],
    standalone: false
})
export class PahafFormComponent implements OnInit {
  @Input() public parentValue;
  @Output() formLoaded = new EventEmitter<void>();
  @Output() formError = new EventEmitter<void>();
  viewData: boolean;
  private apiCallsCompleted = 0;
  private totalApiCalls = 3;

  items: any;
  memberId = '';
  gender: string;
  date: any;
  date_gender: string;
  formDataArray = [];
  indicatorOfConditions = '';
  prevCondition = [];
  poteintialCondition = [];
  prevFlag: boolean;
  ptnFlag: boolean;
  newpoteintialCondition: any;
  pahafYear: string;
  status = {};
  allStatus = [];
  singleMemberdetails: any;
  uniquePrevCondition = [];
  radio_Q2;
  radio_Q3;
  radio_Q4;
  bpTextBox1;
  bpTextBox2;
  bpCheckbox1;
  bpCheckbox2;
  bpCheckbox3;
  bpCheckbox4;
  cb81;
  date1;
  cb811;
  cb82;
  date2;
  cb821;
  cb83;
  date3;
  cb831;
  cb84;
  date4;
  cb841;
  submissionDate;
  result: any[][];
  memberMeasureDatas = [];
  qualityCodingListData = [];
  public measuresListData:any = [];
  public measuresListDataArray:any = [];
  public qualityHeaderList : any = [];
  public qualityCodingList : any = [];
  public dxDt : any = [];
  public hccDt : any = [];
  public resultDx: any [][];
  public resultHcc: any [][];
  public refreshDate: any = [];
  public refreshDateN:any = [];
  public pipe = new DatePipe('en-US');


  constructor(private pahafService: EpahafService) {}

  ngOnInit() {
    //console.log("this.parentValue", this.parentValue);
    this.loadItems();
  }
  loadItems() {
    // this.parentValue.forEach((selctedMember) => {
    // console.log('memberId',selctedMember.memberHmoID);
    let duplicates = [];
    // this.pahafService.getpahafmembermeasures(this.parentValue.memberHmoID).subscribe(e=>{

    // })

    this.pahafService.getpahafconfiginfo().subscribe(
      (response) => {
        let responseData: any;
        responseData = response;
        this.pahafYear = responseData[0].pahafValue;
        this.checkAllApiCallsCompleted();
      },
      (error) => {
        console.error('Error loading pahaf config:', error);
        this.formError.emit();
      }
    );

    this.pahafService.getMeasuresQualityCoding(this.parentValue.memberHmoID).subscribe(
      (resp) => {
        let responseMeasureData: any;
        responseMeasureData = resp.responseDatasArray;
        this.measuresListData = responseMeasureData[0].measuresList;
        if(this.measuresListData) {
        this.measuresListData.forEach((rec) => { 
        this.refreshDate = this.pipe.transform(rec.refreshDate,'MM-dd-yyyy');     
        this.measuresListDataArray.push(rec);  
        })
        if(this.refreshDate)  {
        this.refreshDateN.push(this.refreshDate); 
        }  
        }

        this.qualityCodingListData = responseMeasureData[0].qualityCodingList;
        this.qualityCodingListData.forEach((item, index) => {
          let quality = {} as QualityCodingGuide;
          quality.LOOKUP_ID = item.qualityID;
          quality.LOOKUP_TYPE = item.qualityType;
          quality.LOOKUP_CODE = item.qualityCode;
          quality.LOOKUP_DESCRIPTION = item.qualityDescription;
          quality.LOOKUP_PARENT_ID = item.qualityParentID;
          if (item.qualityType == "Quality_Header") {
            this.qualityHeaderList.push(quality);
          }
          if (item.qualityType == "Quality_Coding") {
            this.qualityCodingList.push(quality);
          }
        });
        this.checkAllApiCallsCompleted();
      },
      (error) => {
        console.error('Error loading measures quality coding:', error);
        this.formError.emit();
      }
    );

    //console.log("measuresListDataArray---:",this.measuresListDataArray[0].refreshDate)

    this.pahafService
      .getPahafDetailsforEachMembers(this.parentValue.memberHmoID)
      .subscribe(
        (combinedREsponses) => {
        //console.log("combinedREsponses", combinedREsponses);
        this.formDataArray = combinedREsponses[0].responseDatasArray;
        this.singleMemberdetails = this.formDataArray[0];
        //console.log('formDataArray',this.formDataArray)
        let filterdPrevCondition = this.formDataArray.filter(
          (obj) => obj.indicator === 'PREVIOUS'
        );
        this.prevCondition = filterdPrevCondition
          .map(function (item) {
            if (item.hccId === '108') {
              item.hccId = '18';
            }

            return item;
          })
          .sort(
            (a, b) =>
              a.memberId - b.memberId ||
              a.hccId - b.hccId ||
              a.dXCode - b.dXCode
          );
        this.prevCondition.map((e) => {
          if (!duplicates.includes(e.dXCode)) {
            this.uniquePrevCondition.push(e);

            duplicates.push(e.dXCode);
          }
        });
        //console.log("this.prevCondition ---:",this.prevCondition);

        const NewPRflag = this.prevCondition.filter(data => data.dXCode == null );
        //console.log("NewPRflag ---:",NewPRflag);

        this.memberMeasureDatas = combinedREsponses[1].responseDatasArray;
        //console.log("uniquePrevCondition----:",this.uniquePrevCondition)

        if (NewPRflag.length > 0) {
          this.prevFlag = false;
        } else {
          this.prevFlag = true;
        }

        //console.log("this.prevFlag----:",this.prevFlag);


        this.poteintialCondition = this.formDataArray
          .filter((obj) => obj.indicator === 'POTENTIAL')
          // .sort(
          //   (a, b) =>
          //     (b.moddcohort &&
          //       a.moddcohort &&
          //       b.moddcohort
          //         .toUpperCase()
          //         .localeCompare(a.moddcohort.toUpperCase())) ||
          //     (a.suspectcondition &&
          //       b.suspectcondition &&
          //       a.suspectcondition.localeCompare(b.suspectcondition)) ||
          //     (a.indicatorDescription &&
          //       b.indicatorDescription &&
          //       a.indicatorDescription.localeCompare(b.indicatorDescription)) ||
          //     (a.indicatorDOS &&
          //       b.indicatorDOS &&
          //       a.indicatorDOS
          //         .split('-')
          //         .reverse()
          //         .join('')
          //         .localeCompare(b.indicatorDOS.split('-').reverse().join('')))
          // );

          //console.log("this.poteintialCondition before----:",this.poteintialCondition)
          this.dxDt = this.poteintialCondition.filter(dxData => dxData.healthplan === 'Navina');
          //console.log("dxDt ----:",this.dxDt);
          this.hccDt = this.poteintialCondition.filter(dxData => dxData.healthplan !== 'Navina');
          //console.log("hccDt-----:",this.hccDt);

          const NewPTflag = this.poteintialCondition.filter(data => data.dXCode == null && data.hccId == null);
        //console.log("NewPTflag ---:",NewPTflag);


                    

        // let grouped = _.groupBy(this.poteintialCondition, "suspectCondition");
        
        // let grouped = _.groupBy(this.poteintialCondition, 'hccDescription');
        // this.result = Object.keys(grouped).map((key) => [
        //   key,
        //   _.uniqBy(grouped[key], 'dXCode'),
        // ]);

        if(this.dxDt.length) {

        let grouped = _.groupBy(this.dxDt, 'dXCode');
        this.resultDx = Object.keys(grouped).map((key) => [
          key,
          _.uniqBy(grouped[key], 'dXCode'),
        ]);

        }
        if(this.hccDt.length) {

        let grouped = _.groupBy(this.hccDt, 'hccDescription');
        this.resultHcc = Object.keys(grouped).map((key) => [
          key,
          _.uniqBy(grouped[key], 'dXCode'),
        ]);

        }

        // console.log("resultDx---:",this.resultDx);
        // console.log("resultHcc--:",this.resultHcc)


        if (NewPTflag.length > 0) {
          this.ptnFlag = false;
        } else {
          this.ptnFlag = true;
        }

        //console.log("this.ptnFlag----:",this.ptnFlag);

        this.formDataArray.map((eachResponse) => {
          this.memberId = eachResponse.memberId;
          if (eachResponse.memberGender === 'F') {
            this.gender = 'Female';
          } else {
            this.gender = 'Male';
          }
          if (eachResponse.memberDateOfBirth) {
            this.date = eachResponse.memberDateOfBirth;
          }
          this.date_gender = this.date + ',' + this.gender;
        });
        //console.log("this.result measuresListDataArray----:",this.refreshDateN);
        let Obj: any = {
          formDataArray: this.formDataArray,
          parentValue: this.parentValue,
          previousCondition: this.uniquePrevCondition,
          poteintialConditionDataDx: this.resultDx,
          poteintialConditionDataHcc: this.resultHcc,
          memberMeasureDatas: this.memberMeasureDatas,
          qualityHeaderList: this.qualityHeaderList,
          qualityCodingList: this.qualityCodingList,
          measuresListData: this.measuresListDataArray,
          refreshDate : this.refreshDateN,
          prevFlag : this.prevFlag,
          ptnFlag : this.ptnFlag,

        };
        this.pahafService.setEpahafpdData(Obj);
        this.checkAllApiCallsCompleted();
      },
      (error) => {
        console.error('Error loading pahaf details:', error);
        this.formError.emit();
      }
    );
    // this.http
    //   .get("http://localhost:4200/assets/backup_pahaf.json")

    // });
  }

  checkAllApiCallsCompleted() {
    this.apiCallsCompleted++;
    if (this.apiCallsCompleted >= this.totalApiCalls) {
      this.formLoaded.emit();
    }
  }

  removeDuplicates(array) {
    return array.filter((a, b) => array.indexOf(a) === b);
  }
  // onlyOne(id) {
  //   $('input[type="checkbox"]').on('change', function () {
  //     $('input[name="' + this.name + '"]')
  //       .not(this)
  //       .prop('checked', false);
  //   });
    // var checkboxes = document.getElementsByName('bcscheckBox1') ;
    // checkboxes.forEach((item) => {
    //     if (item !== checkbox) {item.checked = false}
    // })
  // }


  // onlyOneDxCheckbox() {
  //   $('input[type="checkbox"]').on('change', function () {
  //     $('input[name="' + this.name + '"]')
  //       .not(this)
  //       .prop('checked', false);
  //   });
  // }
  IntermediateFormSave() {}

  clickEvent(event, dxCode) {
    if (this.status) {
      this.status[dxCode] = event.target.id;
    }
    // this.status.push(status);
    // console.log(this.status);
  }
  test(dxCode, type) {
    let classToApply = '';
    if (Object.keys(this.status) && Object.values(this.status).length) {
      Object.keys(this.status).filter((codes: any) => {
        if (codes === dxCode && this.status[codes] === type) {
          classToApply = 'ticked';
        }
      });
    }
    return classToApply;
  }

  getQualityCoding(LOOKUP_ID:any)
  {
    return this.qualityCodingList.filter(x => x.LOOKUP_PARENT_ID == LOOKUP_ID);
  }

}

export interface QualityCodingGuide{
    LOOKUP_ID : string;
    LOOKUP_TYPE : string;
    LOOKUP_CODE : string;
    LOOKUP_DESCRIPTION : string;
    LOOKUP_PARENT_ID : string; 
}
